import styled, { keyframes } from "styled-components"

export const Container = styled.div`
    padding: 70px;
    padding-top: 145px;
    display: block;
    margin: 0 auto;
    font-size: 17px;
    max-width: 1000px;
    background-image: url("feature.gif");
    background-color: black;

    @media (max-width: 700px) { 
        margin-top: 100px;
        padding-top: 75px;
    }
    
    @media (max-width: 400px) { 
        margin-top: 40px;
        padding: 25px;
        padding-top: 75px;
    }
`;


const fadeIn = keyframes`
  from {
    transform: translateY(20%);
    opacity: 0;
  }

  to {
    transform: translateY(0);
    opacity: 1;
  }
  
`;

export const TextOne = styled.p`
    opacity: 0;
    color: #BB86FC;
    margin-bottom: 20px;
    animation: ${fadeIn} 500ms forwards;
    animation-delay: .3s;
`;

export const TextTwo = styled.p`
    opacity: 0;
    color: #f2f2f2;
    font-size: 60px;
    font-weight: bold;
    animation: ${fadeIn} 500ms forwards;
    animation-delay: .5s;

    
    @media (max-width: 700px) { 
        font-size: 50px;
    }

    
    
    @media (max-width: 400px) { 
        font-size: 35px;
    }
`;

export const TextThree = styled.p`
    opacity: 0;
    color: #969696;
    font-size: 40px;
    font-weight: bold;
    animation: ${fadeIn} 500ms forwards;
    animation-delay: .8s;

    
    @media (max-width: 700px) { 
        font-size: 30px;
    }
    @media (max-width: 400px) { 
        font-size: 23px;
    }
`;

export const TextFour = styled.p`
    opacity: 0;
    color: #969696;
    margin-top: 20px;
    margin-bottom: 60px;
    max-width: 500px;
    animation: ${fadeIn} 500ms forwards;
    animation-delay: 1s;
`;

export const Button = styled.a`
    text-decoration: none;
    opacity: 0;
    padding: 17px;
    background: none;
    color: #BB86FC;
    border: solid 2px #BB86FC;
    border-radius: 5px;
    font-size: 17px;
    cursor: pointer;
    animation: ${fadeIn} 500ms forwards;
    animation-delay: 1.2s;
    &:hover {
        background: rgba(255,255,255,0.05);
    }


`;